import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  iframe: {
    height: 0,
    width: 0,
    borderWidth: 0,
    borderColor: 'transparent',
    padding: 0,
    margin: 0
  }
}))
